import { openLinkWithTrack } from '@/common/utilities/nojq/_load.ojolink.js';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';

const SPLIT_CW_4372 = 'movoto-mortgage-cta-CW-4372';
const SPLIT_CW_11302 = 'movoto-CW-11302';

export function resolveMortgagePageCtaAction(getSplit) {
    if (getSplit(SPLIT_CW_4372, 'lower_dtc')) {
        return 'lower';
    }
    if (getSplit(SPLIT_CW_4372, 'mrc')) {
        return 'mrc';
    }
    if (getSplit(SPLIT_CW_11302, 'on14')) {
        return 'lower';
    }
    return 'mrc';
}

function buildLowerRedirectUrl({ glb, zipcode, utmContent }) {
    const lowerUrl =
        glb.env === 'dev'
            ? 'https://lightspeed.partner-testing.lwreng.com/mortgage/lightspeed/partners'
            : 'https://app.lower.com/mortgage/lightspeed/partners';
    let redirectUrl = `${lowerUrl}?partner_name=movoto&rea_question=false&consent_required=true&show_warm_up=false&loan_type=purchase&utm_content=${utmContent}&vendor_lead_unique_id=${glb.user?.id}&redirect_url=${encodeURIComponent('https://www.movoto.com' + location.pathname)}`;
    redirectUrl += `&utm_term=zip=${zipcode}&page_type=${glb.pageType}`;
    return redirectUrl;
}

export function executeMortgagePageLowerCta({ glb, zipcode, utmContent, ctaLabel, evt }) {
    const normalizedUtm = utmContent.toLowerCase().replace(/\s+/g, '_');
    openLinkWithTrack(
        {
            url: glb.appUrl + 'about/confirm-mortgage-lower/',
        },
        {
            ec: 'partner_mortgage_purchase_section',
            en: `partner_mortgage_click_${normalizedUtm}`,
            el: 'Lower',
            props: { link_name: ctaLabel },
        },
        buildLowerRedirectUrl({ glb, zipcode, utmContent: normalizedUtm }),
        { label: 'Lower', linkName: resolveClickCta(ctaLabel, evt, 'SEARCH'), category: 'buy' }
    );
}

export function executeMortgagePageMrcCta({ eventBus, trigger }) {
    eventBus.$emit('dialog-center', {
        name: 'mrcMortgageRates',
        trigger,
        opt: {
            showNormalMrc: true,
            utm_campaign: 'mortgagepages',
            desc: 'getpreapproved',
            cta: 'mortgagepages',
            ga: 'partner_mortgage_page_session',
        },
    });
}

export function handleMortgagePageCta({ getSplit, glb, zipcode, utmContent, ctaLabel, evt, eventBus, trigger }) {
    const action = resolveMortgagePageCtaAction(getSplit);
    if (action === 'lower') {
        executeMortgagePageLowerCta({ glb, zipcode, utmContent, ctaLabel, evt });
        return;
    }
    executeMortgagePageMrcCta({ eventBus, trigger });
}
